export default "__VITE_ASSET__841fb52e__"